import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";

import "./Header.scss";

const Header = (props) => {
  const { state, dispatch } = useContext(ContextOne);
  const { loggedIn } = state;

  const [organizations, setOrganizations] = useState(null);
  const [activeOrganization, setActiveOrganization] = useState(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });

    const data = await ApiService.getOrganizations();
    setOrganizations(data);

    dispatch({ type: "loading", val: false });
  };

  const handleLogout = (event) => {
    localStorage.removeItem("organization");
    setActiveOrganization(null);

    AuthService.logout();
    dispatch({ type: "loggedIn", val: false });
    dispatch({ type: "user", val: false });
    navigate("/login");
  };

  const handleSelectOrganization = (o) => {
    setActiveOrganization(o);
    localStorage.setItem("organization", JSON.stringify(o));
  };

  useEffect(() => {
    fetchData();
    setActiveOrganization(JSON.parse(localStorage.getItem("organization")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="header-component">

      <Navbar expand="lg">
        <Navbar.Brand>
          <Link to="/" className="company-name">
            {/* <img height="75px" alt="Pure" src={process.env.PUBLIC_URL + "/img/pure-logo-header.png"} /> */}
            ONE TAKE AUDIO
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler"/>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            { !loggedIn &&
              <div className="nav-link" role="button">
                <Link to="/login">login</Link>
              </div>
            }
            { loggedIn &&
              <NavDropdown title={activeOrganization?.name || "Select Organization"} id="nav-dropdown-organization">
                { 
                  organizations &&
                  organizations.map(o =>
                    <NavDropdown.Item
                      eventKey="1.1"
                      onClick={() => { handleSelectOrganization(o) }}
                      active={activeOrganization?.id === o.id}
                      >
                     {o.name}
                    </NavDropdown.Item>
                  )
                }
              </NavDropdown>
            }
            { loggedIn &&
              <NavDropdown
                title={
                  <FontAwesomeIcon icon={faBars} />
                }
                id="nav-dropdown-items"
                >
                <NavDropdown.Item
                  eventKey="4.1"
                  as={Link}
                  to="/projects"
                  >
                  Projects
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="4.1"
                  as={Link}
                  to="/ai-models"
                  >
                  Models
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="4.1"
                  as={Link}
                  to="/organizations"
                  >
                  Organizations
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="4.1"
                  as={Link}
                  to="/about"
                  >
                  About
                </NavDropdown.Item>
              </NavDropdown>
            }
            { loggedIn &&
              <NavDropdown
                title={
                  <FontAwesomeIcon icon={faUser} />
                }
                id="nav-dropdown-user"
                >
                <NavDropdown.Item
                  eventKey="4.1"
                  as={Link}
                  to="/user-profile"
                  >
                  User Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="4.2"
                  onClick={handleLogout}
                  >
                  Sign Out
                </NavDropdown.Item>
              </NavDropdown>
            }
        </Nav>
        </Navbar.Collapse>
      </Navbar>

    </div>
  );
};

export default Header;
